<template>
  <div class="container">
    <loading :active="loading" :is-full-page="true" loader="bars"></loading>
    <div class="row">
      <!-- <div class="col-md-12 mt-5">
          <Bread_crumbs />
          <router-link
            to="/doctors/add"
            class="c-button cbg-primary mb-2 float-end"
            >Add Doctor</router-link
          >
        </div> -->
      <div class="col-md-12">
        <data-table
          :columns="columns"
          :module="module"
          :items="items"
          :isEdit="true"
          :isDelete="true"
          :viewDetail="true"
          :unBlock="true"
          :isBlock="true"
          :isAction="false"
          :isSearch="false"
          @viewItem="fetch"
          @deleted="fetch"
          @nextPage="nextPage"
          @search="fetch"
          @clear="fetch"
        ></data-table>
      </div>
    </div>
  </div>
</template>
    <script>
import Bread_crumbs from "@/components/bread_crumbs.vue";
import DataTable from "@/components/dataTable.vue";

export default {
  components: {
    DataTable,
    Bread_crumbs,
  },
  props: {
    doctor_id: String,
  },
  data() {
    return {
      items: [],
      columns: [
        {
          text: "Name",
          value: "f_name",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Age",
          value: "age",
        },
        {
          text: "Blood Group",
          value: "blood_group",
        },
        {
          text: "Number",
          value: "phone_no",
        },
      ],
      module: "doctors",
      loading: false,
    };
  },
  mounted() {
    const id = this.doctor_id;
    this.fetch(id);
  },
  methods: {
    fetch(id) {
      console.log("fetched successfully");
      this.loading = true;
      this.$store
        .dispatch("doctors/getSingle", { id, patient: true })
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e.error);
        });
    },
  },
};
</script>
    